import 'App_new.css';
import { AuthContextProvider } from 'hooks/useAuth';
import { CompanyContextProvider } from 'hooks/useCompany';
import { RouterProvider } from 'react-router-dom';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import router from 'routes';
import Snackbar from 'components/@extended/Snackbar';
import Locales from 'components/Locales';
import { ModalProvider } from '../src/components/Modal/ModalContext'; // <-- ✅ Import this
import DetectRefresh from 'utils/detectRefersh';

function App() {
  // useSync();
  return (
    <ThemeCustomization>
      <Locales>
        <ScrollTop>
          <CompanyContextProvider>
            <AuthContextProvider>
              <ModalProvider> {/* ✅ Wrap everything that uses useModal */}
                <>
                  <DetectRefresh />
                  <RouterProvider router={router} />
                  <Snackbar />
                </>
                {/* <AppContent /> */}
              </ModalProvider>
            </AuthContextProvider>
          </CompanyContextProvider>
        </ScrollTop>
      </Locales>
    </ThemeCustomization>
  );
}
// const AppContent = () => {
//   useSync(); // ✅ Now this has access to CompanyContext
//   return (
//     <>
//       <DetectRefresh />
//       <RouterProvider router={router} />
//       <Snackbar />
//     </>
//   );
// };
export default App;
